attributes = require('../locales/pt_BR.coffee').attributes

module.exports =
  computed:
    submittable: ->
      !(@pristine || @errors.any())

  methods:
    select: (objId, objClass) ->
      @deSelect()
      wrapNode = document.getElementById(objId)
      if (document.selection)
        range = document.body.createTextRange()
        range.moveToElementText(wrapNode.getElementsByClassName(objClass)[0])
        range.select()
      else if (window.getSelection)
        range = document.createRange()
        range.selectNode(wrapNode.getElementsByClassName(objClass)[0])
        window.getSelection().addRange(range)
    
    deSelect: ->
      if(document.selection)
        document.selection.empty()
      else if (window.getSelection)
        window.getSelection().removeAllRanges()

    validateEmail: (email) ->
      regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      regex.test(String(email).toLowerCase())

    setDirty: ->
      @pristine = false

    handleApiErrors: (response, options={}) ->
      Loader.off()
      response_body = response.body
      return unless response_body

      @addApiErrorMessages(response_body)

      @addExtraAttributesErrors(response_body, options.extra_attributes) if options.extra_attributes

      for key in Object.keys(@$validator.fieldBag.fields)
        normalized_key = key.replace(".", "_")
        keyErrors = response_body[key]
        if keyErrors
          for error in keyErrors
            @errors.add(normalized_key, @errorMessage(key, error))

    addApiErrorMessages: (response_body) ->
      errors = response_body.errors
      baseErrors = response_body.base

      @apiErrorMessages = errors || []
      @apiErrorMessages = @apiErrorMessages.concat(baseErrors) if baseErrors

    addExtraAttributesErrors: (response_body, extra_attributes) ->
      for key in extra_attributes
        keyErrors = response_body[key]
        if keyErrors
          for error in keyErrors
            @apiErrorMessages = @apiErrorMessages.concat(@errorMessage(key, error))

    errorMessage: (key, error) ->
      if (attributes[key] != undefined)
        'O campo ' + attributes[key] + ' ' + error
      else
        'O campo ' + error

    unknownError: ->
      Loader.off()
      alertify.error "Ops, algo deu errado!"



// WEBPACK FOOTER //
// ./src/helpers/form.coffee